import { useState } from 'react';
import LockOutlinedIcon from '@mui/icons-material/LockOutlined';
import { Card } from '../../design-system';
import PasswordResetDialog from '../ui/PasswordResetDialog';
import styles from './account.module.css';

/**
 * Password section of the My Account page. The actual change-password form is
 * Amplify UI's AccountSettings.ChangePassword, already wrapped in
 * PasswordResetDialog — this card just surfaces the entry point.
 */
export default function PasswordCard({ username }) {
  const [open, setOpen] = useState(false);

  return (
    <Card padding="lg">
      <div className={styles.cardHead}>
        <LockOutlinedIcon className={styles.cardIcon} aria-hidden="true" />
        <div className={styles.cardHeadText}>
          <div className={styles.cardTitle}>Password</div>
          <div className={styles.cardDesc}>Change the password you use to sign in.</div>
        </div>
        <button className={styles.secondaryBtn} onClick={() => setOpen(true)}>
          Change password
        </button>
      </div>
      <PasswordResetDialog username={username} open={open} onClose={() => setOpen(false)} />
    </Card>
  );
}
